import { useContactTags } from 'src/api/core/enumOptionAssociations/useEnumOptionAssociations';
import { TagsDisplay } from 'src/components/rebates/TagsDisplay';

/**
 * Inline tags cell for a single contact (`comm_contacts` row).
 *
 * Reads/writes the contact's tags via the shared core-enum association system
 * (entityType `contact` + the org-configurable "Contact Tags" enum), rendering
 * them as removable pills plus an "Add Tag" dropdown. Used by both the company
 * Contacts tab and the organization Address Book, since both surface the same
 * underlying Contact records.
 */
export function ContactTagsCell({ contactId }: { contactId: string }) {
  const {
    currentTags,
    availableTags,
    currentTagIds,
    isLoading,
    isUpdating,
    isCreatingTag,
    areOptionsLocked,
    handleAddTag,
    handleRemoveTag,
    handleCreateTag,
  } = useContactTags(contactId);

  return (
    <TagsDisplay
      currentTags={currentTags}
      availableTags={availableTags}
      currentTagIds={currentTagIds}
      isLoading={isLoading}
      isUpdating={isUpdating}
      isCreatingTag={isCreatingTag}
      onAddTag={handleAddTag}
      onRemoveTag={handleRemoveTag}
      onCreateTag={areOptionsLocked ? undefined : handleCreateTag}
      layout="compact"
      showEmptyState={false}
    />
  );
}
